import { GestureArea } from '//www.tandemcoffee.com/cdn/shop/t/144/assets/theme.js?v=176156073783256390011787259262';

function attachSwipe(root) {
  if (root.dataset.swipeAttached || !root.querySelector('.prev-next-buttons')) return;
  root.dataset.swipeAttached = 'true';

  const controller = new AbortController();
  new GestureArea(root, { signal: controller.signal });
  root.addEventListener('swipeleft', () => {
    root.dispatchEvent(new CustomEvent('control:next', { bubbles: true, cancelable: true }));
  }, { signal: controller.signal });
  root.addEventListener('swiperight', () => {
    root.dispatchEvent(new CustomEvent('control:prev', { bubbles: true, cancelable: true }));
  }, { signal: controller.signal });
}

function attachAll() {
  document.querySelectorAll('multiple-images-with-text').forEach(attachSwipe);
}

attachAll();
document.addEventListener('shopify:section:load', attachAll);
